<template>
	<div class="notifier" v-if="showedErrors.length > 0">
		<div class="notifier__image">
			<img src="/img/frontend/calc/icon/warning.svg" alt="Figyelmeztetés" />
		</div>
		<span v-for="(error, index) in showedErrors" :key="index" v-html="error"></span>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { sumBy } from 'lodash';

const warningTexts = {
	real_estate: {
		bottomLimit:
			'A túl alacsony biztosítási összeg és az alulbiztosítottság elkerülése érdekében, kérjük adjon meg magasabb ingatlan értéket vagy válassza a biztosítók által javasolt biztosítási összeg jelölőnégyzetet!',
		topLimit:
			'Felhívjuk figyelmét, hogy a túl magas biztosítási összeg miatt a(z) <b>{insurers} biztosító nem ad ajánlatot!!</b> Ha az összes biztosító ajánlatát meg kívánja tekinteni a díjszámítási eredmények oldalon, kérjük, írjon be alacsonyabb összeget!',
		maxFloorArea:
			'Felhívjuk figyelmét, hogy az ingatlan túl nagy alapterülete miatt a(z) <b>{insurers} biztosító nem ad ajánlatot!</b>',
	},
	movables: {
		bottomLimit:
			'A túl alacsony biztosítási összeg és az alulbiztosítottság elkerülése érdekében, kérjük adjon meg magasabb összeget!',
		topLimit:
			'Felhívjuk figyelmét, hogy a túl magas biztosítási összeg miatt a(z) <b>{insurers} biztosító nem ad ajánlatot!</b> Ha az összes biztosító ajánlatát meg kívánja tekinteni a díjszámítási eredmények oldalon, kérjük, írjon be alacsonyabb összeget!',
	},
	wall_type: {
		wallTypeMixed:
			'Felhívjuk figyelmét, hogy a Colonnade biztosító a falazat típusa miatt nem ad ajánlatot, természetesen a többi biztosító ajánlatát megtekintheti!',
	},
	outbuilding: {
		bottomLimit:
			'Felhívjuk figyelmét, hogy túl alacsony biztosítási összeg esetén bizonyos biztosítók nem adnak ajánlatot! Kérjük, legalább 200.000 Ft/m2 ár alapján kalkulált összeget írjon be!',
		topLimit:
			'Felhívjuk figyelmét, hogy a túl magas biztosítási összeg miatt a(z) <b>{insurers} biztosító nem ad ajánlatot!!</b> Ha az összes biztosító ajánlatát meg kívánja tekinteni a díjszámítási eredmények oldalon, kérjük, írjon be alacsonyabb összeget!',
	},
    valuables: {
        topLimit: '500 eFt feletti összegű értéktárgyak esetén az Alfa biztosító nem ad ajánlatot!'
    }

};

const avaibleInsurers = {
	kobe: 'Köbe',
	colonnade: 'Colonnade',
    granit: 'Gránit',
	union: 'Union',
	allianz: 'Allianz',
	generali: 'Generali',
};

const baseState = () => {
	return {
		errors: {
			bottomLimit: false,
			topLimit: false,
			wallTypeMixed: false,
			maxFloorArea: false,
            maxValuables: false,
		},
		insurers: {
            granit: false,
			kobe: false,
			colonnade: false,
			generali: false,
		},
		showedErrors: [],
	};
};

export default {
	mounted() {
		if (
			this.getRealEstate.movable_value !== null ||
			this.getRealEstate.insurance_value !== null ||
			this.getRealEstate.wall_type !== null ||
			(this.getOutbuildings.length > 0 && this.getOutbuildings[this.index].insurance_value !== null)
		) {
			this.makeErrors();
		}
	},
	props: {
		options: { type: Object, default: () => {} },
		index: { type: Number, default: null },
	},
	computed: {
		...mapGetters(['getRealEstate', 'getOutbuildings', 'getMakeNotify', 'getValuableSum']),
		computedErrors() {
			Object.assign(this.$data, baseState());

			if (this.options.notify === 'real_estate') {
				this.checkRealEstateHasError();
			}

			if (this.options.notify === 'movables') {
				this.checkMovableHasError();
			}

			if (this.options.notify === 'wall_type') {
				this.checkWallTypeHasError();
			}

			if (this.options.notify === 'outbuilding') {
				this.checkOutbuildingHasError();
			}

            if (this.options.notify === 'valuables') {
                this.checkValuablesHasError();
            }

			return this.makeErrorsResults(this.options.notify);
		},
		computedInsurersNames() {
			return Object.keys(this.insurers)
				.filter(insurer => this.insurers[insurer])
				.map(insurer => avaibleInsurers[insurer])
				.join(', ');
		},
	},
	data() {
		return baseState();
	},
	methods: {
		...mapMutations(['setMakeNotify']),
		makeErrors() {
			Object.assign(this.$data, baseState());

			if (this.options.notify === 'real_estate') {
				this.checkRealEstateHasError();
			}

			if (this.options.notify === 'movables') {
				this.checkMovableHasError();
			}

			if (this.options.notify === 'wall_type') {
				this.checkWallTypeHasError();
			}

			if (this.options.notify === 'outbuilding') {
				this.checkOutbuildingHasError();
			}

            if (this.options.notify === 'valuables') {
                this.checkValuablesHasError();
            }

			this.showedErrors = this.makeErrorsResults(this.options.notify);
			this.setMakeNotify(false);
		},
		checkRealEstateHasError() {
			if (this.getRealEstate.insurance_value !== null && this.getRealEstate.floor_area !== null) {
				const squareMeterPrice = this.getRealEstate.insurance_value / this.getRealEstate.floor_area;
				let outbuildingSquareMeterPrice = 0;

				if (squareMeterPrice < 400000) {
					this.errors.bottomLimit = true;
				}

				if (this.getRealEstate.insurance_value > 200000000 || squareMeterPrice > 1200000) {
					this.errors.topLimit = true;
					this.insurers.granit = true;
				}

				if (this.getRealEstate.insurance_value > 300000000) {
					this.errors.topLimit = true;
					this.insurers.generali = true;
				}

				if (this.getOutbuildings.length > 0) {
					const sumInsuranceValue = sumBy(this.getOutbuildings, 'insurance_value');
					const sumFloorArea = sumBy(this.getOutbuildings, 'floor_area');
					outbuildingSquareMeterPrice = sumInsuranceValue / sumFloorArea;

					if (sumInsuranceValue > 20000000 || outbuildingSquareMeterPrice > 360000) {
						this.errors.topLimit = true;
						this.insurers.granit = true;
					}
				}

				if (this.getRealEstate.floor_area > 300) {
					this.errors.maxFloorArea = true;
					this.insurers.kobe = true;
				}

				const allInsuranceValue = this.getRealEstate.insurance_value + outbuildingSquareMeterPrice;

				if (allInsuranceValue > 250000000) {
					this.errors.topLimit = true;
					this.insurers.colonnade = true;
				}
			}
		},
		checkMovableHasError() {
			if (this.getRealEstate.movable_value !== null) {
				const squareMeterPrice = this.getRealEstate.movable_value / this.getRealEstate.floor_area;
				let sumOutbuildingMovableValue = 0;

				if (this.getOutbuildings.length > 0) {
					sumOutbuildingMovableValue = sumBy(this.getOutbuildings, 'movable_value');

					if (sumOutbuildingMovableValue > 20000000) {
						this.errors.topLimit = true;
						this.insurers.granit = true;
					}
				}

				if (
					this.getRealEstate.movable_value > 75000000 ||
					this.getRealEstate.movable_value + sumOutbuildingMovableValue > 75000000
				) {
					this.errors.topLimit = true;
					this.insurers.granit = true;
				}

				if (this.getRealEstate.movable_value + sumOutbuildingMovableValue > 30000000) {
					this.errors.topLimit = true;
					this.insurers.colonnade = true;
				}

				if (this.getRealEstate.movable_value < 6130000) {
					this.errors.bottomLimit = true;
					this.insurers.generali = true;
				}

				if (this.getRealEstate.movable_value > 30000000) {
					this.errors.topLimit = true;
					this.insurers.generali = true;
				}
			}

			if (this.getRealEstate.movable_value !== null && this.getRealEstate.floor_area !== null) {
				const squareMeterPrice = this.getRealEstate.movable_value / this.getRealEstate.floor_area;

				if (squareMeterPrice < 100000) {
					this.errors.bottomLimit = true;
				}
			}
		},
        checkValuablesHasError() {
            console.log(this.getValuableSum);
            if (this.getValuableSum > 500000) {
                this.errors.maxValuables = true;
            }
        },
		checkWallTypeHasError() {
			if (this.getRealEstate.wall_type !== null) {
				this.errors.wallTypeMixed = this.getRealEstate.wall_type === 7;
			}
		},
		checkOutbuildingHasError() {
			if (this.getOutbuildings[this.index].insurance_value !== null) {
				if (this.getOutbuildings[this.index].floor_area !== null) {
					const squareMeterPrice =
						this.getOutbuildings[this.index].insurance_value / this.getOutbuildings[this.index].floor_area;

					if (squareMeterPrice < 200000) {
						this.errors.bottomLimit = true;
					}
				}

				if (this.getOutbuildings[this.index].insurance_value > 30000000) {
					this.errors.topLimit = true;
					this.insurers.generali = true;
				}
			}
		},
		makeErrorsResults(type) {
			let result = [];

			if (this.errors.bottomLimit) {
				result.push(warningTexts[type].bottomLimit);
			}

			if (this.errors.topLimit) {
				result.push(warningTexts[type].topLimit.replace('{insurers}', this.computedInsurersNames));
			}

			if (this.errors.maxFloorArea) {
				result.push(warningTexts[type].maxFloorArea.replace('{insurers}', this.computedInsurersNames));
			}

			if (this.errors.wallTypeMixed) {
				result.push(warningTexts[type].wallTypeMixed);
			}

            if(this.errors.maxValuables) {
                result.push(warningTexts[type].topLimit);
            }

			return result;
		},
	},
	watch: {
		getMakeNotify(newVal) {
			if (newVal) {
				this.makeErrors();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.notifier {
	position: relative;
	display: flex;
	align-items: center;
	padding: 15px;
	margin-bottom: 15px;
	border: 1px solid #ffc107;
	border-radius: 8px;
	background-color: rgba($color: #ffc107, $alpha: 0.2);
	color: #1f2835;
	line-height: 22px;
	overflow: hidden;
	width: 100%;

	@media screen and (max-width: 600px) {
		flex-direction: column-reverse;
		align-items: end;
	}

	&__image {
		position: absolute;
		opacity: 0.6;
		z-index: -1;
		right: -22px;
		bottom: -18px;

		img {
			width: 70px;
		}
	}

	span {
		display: block;
		margin-left: 15px;

		@media screen and (max-width: 500px) {
			margin-left: 0;
		}
	}
}
</style>
